import React from 'react';
import { CheckCircle2Icon, XCircleIcon, BookOpenIcon, ActivityIcon, UtensilsIcon, SunriseIcon, MoonIcon } from 'lucide-react';
export function ProductSection() {
  return <section className="py-16 md:py-24 bg-stone-50" data-id="element-136">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-137">
        {/* What you get */}
        <div className="mb-20" data-id="element-138">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-139">
            Lo que obtienes hoy
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-140">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-141">
              <div className="w-14 h-14 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mb-4" data-id="element-142">
                <BookOpenIcon className="h-7 w-7" data-id="element-143" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-144">
                La Guía Maestra
              </h3>
              <p className="text-gray-600" data-id="element-145">
                El Protocolo de Reinicio de Cortisol (PDF paso a paso).
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-146">
              <div className="w-14 h-14 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mb-4" data-id="element-147">
                <ActivityIcon className="h-7 w-7" data-id="element-148" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-149">
                Técnica de Bombeo Diamante
              </h3>
              <p className="text-gray-600" data-id="element-150">
                El mapa visual para desinflamar el abdomen en 48 horas.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-151">
              <div className="w-14 h-14 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mb-4" data-id="element-152">
                <UtensilsIcon className="h-7 w-7" data-id="element-153" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-154">
                Menú de Rescate de 72h
              </h3>
              <p className="text-gray-600" data-id="element-155">
                Qué comer exactamente para estabilizar tu azúcar en sangre.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center lg:col-start-1 lg:col-end-3 lg:w-1/2 lg:mx-auto lg:translate-x-1/2" data-id="element-156">
              <div className="w-14 h-14 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mb-4" data-id="element-157">
                <SunriseIcon className="h-7 w-7" data-id="element-158" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-159">
                Checklist de Mañana
              </h3>
              <p className="text-gray-600" data-id="element-160">
                Tu rutina de oro para empezar el día con energía real, sin
                estrés.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center lg:col-start-2 lg:col-end-4 lg:w-1/2 lg:mx-auto lg:translate-x-1/2" data-id="element-161">
              <div className="w-14 h-14 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mb-4" data-id="element-162">
                <MoonIcon className="h-7 w-7" data-id="element-163" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-164">
                Ritual de Sueño Profundo
              </h3>
              <p className="text-gray-600" data-id="element-165">
                El secreto para no volver a despertar a las 3 AM.
              </p>
            </div>
          </div>
        </div>

        {/* How it works */}
        <div className="mb-20 bg-white rounded-3xl shadow-xl border border-gray-100 p-8 md:p-12" data-id="element-166">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-167">
            Cómo funciona
          </h2>
          <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-teal-200 before:to-transparent" data-id="element-168">
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-169">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-teal-500 text-white font-bold shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-170">
                1
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-stone-50 p-6 rounded-2xl border border-stone-100 shadow-sm" data-id="element-171">
                <h3 className="font-bold text-xl text-gray-900 mb-2" data-id="element-172">
                  Paso 1: Detectar
                </h3>
                <p className="text-gray-600" data-id="element-173">
                  Usas el Test de Identificación de Grasa Adrenal para mapear tu
                  nivel de estrés.
                </p>
              </div>
            </div>

            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-174">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-teal-500 text-white font-bold shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-175">
                2
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-stone-50 p-6 rounded-2xl border border-stone-100 shadow-sm" data-id="element-176">
                <h3 className="font-bold text-xl text-gray-900 mb-2" data-id="element-177">
                  Paso 2: Resetear
                </h3>
                <p className="text-gray-600" data-id="element-178">
                  Aplicas el Bombeo Diamante y el Menú de Rescate para limpiar
                  receptores hormonales.
                </p>
              </div>
            </div>

            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-179">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-teal-500 text-white font-bold shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-180">
                3
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-stone-50 p-6 rounded-2xl border border-stone-100 shadow-sm" data-id="element-181">
                <h3 className="font-bold text-xl text-gray-900 mb-2" data-id="element-182">
                  Paso 3: Sostener
                </h3>
                <p className="text-gray-600" data-id="element-183">
                  Sigues los micro-hábitos nocturnos para mantener el cortisol
                  bajo y la energía alta.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Who is it for */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-184">
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-green-500" data-id="element-185">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-186">
              <CheckCircle2Icon className="h-6 w-6 text-green-500 mr-2" data-id="element-187" />
              Para quién es esto
            </h3>
            <ul className="space-y-4" data-id="element-188">
              <li className="flex items-start" data-id="element-189">
                <CheckCircle2Icon className="h-5 w-5 text-green-500 mr-3 mt-0.5 shrink-0" data-id="element-190" />
                <span className="text-gray-700" data-id="element-191">
                  Mujeres de 40 a 55 años en perimenopausia o menopausia.
                </span>
              </li>
              <li className="flex items-start" data-id="element-192">
                <CheckCircle2Icon className="h-5 w-5 text-green-500 mr-3 mt-0.5 shrink-0" data-id="element-193" />
                <span className="text-gray-700" data-id="element-194">
                  Mujeres que sienten que "se inflaman con solo mirar el pan".
                </span>
              </li>
              <li className="flex items-start" data-id="element-195">
                <CheckCircle2Icon className="h-5 w-5 text-green-500 mr-3 mt-0.5 shrink-0" data-id="element-196" />
                <span className="text-gray-700" data-id="element-197">
                  Profesionales y madres con altos niveles de responsabilidad
                  diaria.
                </span>
              </li>
              <li className="flex items-start" data-id="element-198">
                <CheckCircle2Icon className="h-5 w-5 text-green-500 mr-3 mt-0.5 shrink-0" data-id="element-199" />
                <span className="text-gray-700" data-id="element-200">
                  Personas que sufren de fatiga crónica y "niebla mental".
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-red-500" data-id="element-201">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-202">
              <XCircleIcon className="h-6 w-6 text-red-500 mr-2" data-id="element-203" />
              Para quién NO es
            </h3>
            <ul className="space-y-4" data-id="element-204">
              <li className="flex items-start" data-id="element-205">
                <XCircleIcon className="h-5 w-5 text-red-500 mr-3 mt-0.5 shrink-0" data-id="element-206" />
                <span className="text-gray-700" data-id="element-207">
                  Quienes buscan una pastilla quemagrasas milagrosa.
                </span>
              </li>
              <li className="flex items-start" data-id="element-208">
                <XCircleIcon className="h-5 w-5 text-red-500 mr-3 mt-0.5 shrink-0" data-id="element-209" />
                <span className="text-gray-700" data-id="element-210">
                  Atletas de alto rendimiento que no sufren de estrés crónico.
                </span>
              </li>
              <li className="flex items-start" data-id="element-211">
                <XCircleIcon className="h-5 w-5 text-red-500 mr-3 mt-0.5 shrink-0" data-id="element-212" />
                <span className="text-gray-700" data-id="element-213">
                  Personas que no están dispuestas a dedicar 5 minutos al día a
                  su salud.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}